<template>
	<div class="pl10 mt20">
		<span class="dib">税务信息</span><span class="line"></span>
		<div class="mt20">
			<el-form :model="financeData" label-width="207px" class="demo-ruleForm">
				<!-- 纳税人识别号 -->
			  <el-form-item label="纳税人识别号：">
				<span>{{ financeData.taxpayerRegistrationCode }}</span>
			  </el-form-item>
			  <!-- 纳税人类型 -->
				<el-form-item label="纳税人类型：" class="mt20">
					<span v-if="financeData.taxpayerType == 1">一般纳税人</span>
					<span v-if="financeData.taxpayerType == 2">小规模纳税人</span>
				</el-form-item>
				<el-form-item v-if="financeData.taxpayerType == 1" label="一般纳税人资格认定表："  prop="generalTaxpayerFile">
					<div>
						<img @click="previewPic($event)"  v-for="gtFile in financeData.generalTaxpayerFile.split(',')" class="pic_skan" :src="gtFile">
					</div>
				</el-form-item>
				<span class="dib">货款支付账户</span><span class="second_line"></span>
				<!-- 银行开户名 -->
				<el-form-item label="银行开户名：">
					<span>{{ financeData.accountName }}</span>
				</el-form-item>
				<!-- 银行帐号 -->
				<el-form-item label="银行帐号：">
				  <span>{{ financeData.accountNumber }}</span>
				</el-form-item>
				<!-- 开户银行 -->
				<el-form-item label="开户银行：" >
				  <span>{{ financeData.bankName }}</span>
				</el-form-item>
				<el-form-item v-if="financeData.registeredCountry != 1" label="SwiftCode：" >
					<span>{{ financeData.swiftCode }}</span>
				</el-form-item>
				<!-- 省份 -->
				<el-form-item v-if="financeData.registeredCountry == 1" label="省：">
					<span>{{ financeData.province }}</span>
				</el-form-item>
				<!-- 城市 -->
				<el-form-item v-if="financeData.registeredCountry == 1" label="市：" >
					<span>{{ financeData.city }}</span>
				</el-form-item>
			</el-form>
		</div>
		<!--预览图片-->
		<el-dialog :visible.sync="dialogVisible" size="small">
			<img  width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
            return {
				// 图片预览
				dialogImageUrl: '',
				dialogVisible: false,
                generalTaxpayerFileArray:[],
                financeData:{
                    generalTaxpayerFile:""
				}
            };
		},
		methods: {
            initFinanceInfo(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findFinancialInfo',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.financeData = result.data;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			}
		},
		mounted () {
            var supplierApplyId=this.$route.query.supplierApplyId;
            this.initFinanceInfo(supplierApplyId);
        },
	}
</script>

<style type="text/css" lang="less" scoped>
	.line {
		margin-left: 3%;
		display: inline-block;
		width: 91%;
		height: 1px;
		border-bottom: 1px dashed #999;
		vertical-align: middle;
	}
	.second_line {
		margin-left: 3%;
		display: inline-block;
		width: 88%;
		height: 1px;
		border-bottom: 1px dashed #666;
		vertical-align: middle;
	}
	.pic_tip {
		font-size: 12px;
		color: #ff4949;
		line-height: 1px;
		padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
	}
	.pic_skan {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// financeInfo.vue?f7b5f26c